<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-expansion-panel expand class="grey lighten-3">
          <v-expansion-panel-content v-model="projectPanel" class="grey lighten-4">
            <div
              slot="header"
              class="font-weight-medium grey--text text--darken-2 vertical-center-container"
            >
              <v-icon
                :color="projectColor"
                class="mr-2"
              >{{this.$store.state.global.pages.project.icon}}</v-icon>Inductions
            </div>

            <v-list subheader>
              <v-list-tile v-for="project in projects" :key="project.id" fluid>
                <v-flex xs8>
                  <v-checkbox
                    v-model="selectedProjects"
                    :label="project.name"
                    :value="project.id"
                    :color="projectColor"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs4 v-if="isDriver">
                  <v-text-field
                    @input="$emit('triggerInductionChange')"
                    v-model="selectedInductions[project.id]"
                    label="Driver Induction Card #"
                    :disabled="!selectedProjects.includes(project.id)"
                  ></v-text-field>
                </v-flex>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-checkbox v-model="selectAllProjects" :color="projectColor">
                  <div slot="label" class="font-weight-bold">Select All</div>
                </v-checkbox>
              </v-list-tile>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    projects: Array,
    currentProjects: {
      type: Array,
      default: () => [],
    },
    currentInductions: {
      type: Object,
      default: () => ({}),
    },
    discarding: Boolean,
    isDriver: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      projectPanel: false,
      selectedProjects: [...this.currentProjects],
      selectedInductions: Object.assign({}, this.currentInductions),
      selectAllProjects: false,
      allProjects: [],
      projectColor: this.$store.state.global.pages.project.color,
    }
  },
  watch: {
    selectedProjects(val) {
      this.$emit('selectedChanged', val)
    },
    selectedInductions: {
      deep: true,
      handler(val) {
        this.$emit('selectedInductionsChanged', val)
      },
    },
    selectAllProjects(val) {
      val
        ? (this.selectedProjects = this.allProjects)
        : (this.selectedProjects = [])
    },
    discarding(val) {
      if (val) {
        this.selectedProjects = this.currentProjects
        this.$emit('discard')
      }
    },
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      for (const project of this.projects) {
        this.allProjects.push(project.id)
      }
    },
  },
}
</script>

<style>
</style>